import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";
import { Pagination } from "@mui/material";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ConfirmDeleteDialog, InfoDialog, Loader, ScrollToTop, SearchBar } from "../../../components";
import { ShowTableDataPermohonan } from "../../../components/ShowTable";

const TampilDataPermohonan = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.pathname.split("/")[2];

  const [isDataPermohonanExist, setIsDataPermohonanExist] = useState(false);
  const [namaPemohon, setNamaPemohon] = useState(null);
  const [statusDokumen, setStatusDokumen] = useState("");
  const [keteranganSusulan, setKeteranganSusulan] = useState("");
  const [noJual, setNoJual] = useState("");
  const [nopol, setNopol] = useState("");
  const [alamat, setAlamat] = useState("");
  const [statusRo, setStatusRo] = useState("");
  const [butuhVerifikasi, setButuhVerifikasi] = useState("");
  const [dataPermohonansData, setDataPermohonansData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteError, setDeleteError] = useState("");
  let [page, setPage] = useState(0);
  const [limit] = useState(20);
  const [pages, setPages] = useState(0);
  const [query, setQuery] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    id ? getDataPermohonanById() : setIsDataPermohonanExist(false);
  }, [id]);

  useEffect(() => {
    getDataPermohonans();
  }, [page, searchTerm]);

  const handleAuthError = (err) => {
    if (err.response?.status === 401) {
      dispatch({ type: "LOGOUT" });
      navigate("/");
    }
  };

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  const getDataPermohonans = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${tempUrl}/dataPermohonansPagination?search_query=${encodeURIComponent(searchTerm)}&page=${page}&limit=${limit}`,
        {
          id: user._id,
          token: user.token,
        },
      );
      setQuery(searchTerm);
      setDataPermohonansData(response.data.dataPermohonans || response.data.admins || []);
      setPage(response.data.page);
      setPages(response.data.totalPage);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil data permohonan.");
    }
    setLoading(false);
  };

  const getDataPermohonanById = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/dataPermohonans/${id}`, {
        id: user._id,
        token: user.token,
      });
      setIsDataPermohonanExist(true);
      setNamaPemohon(response.data.namaPemohon);
      setStatusDokumen(response.data.statusDokumen);
      setKeteranganSusulan(response.data.keteranganSusulan);
      setNoJual(response.data.noJual);
      setNopol(response.data.nopol);
      setAlamat(response.data.alamat);
      setStatusRo(response.data.statusRo);
      setButuhVerifikasi(response.data.butuhVerifikasi);
    } catch (err) {
      handleAuthError(err);
      setError(err.response?.data?.message || "Gagal mengambil detail data permohonan.");
    }
    setLoading(false);
  };

  const deleteDataPermohonan = async () => {
    setShowDeleteConfirm(false);
    setLoading(true);
    try {
      await axios.post(`${tempUrl}/deleteDataPermohonan/${id}`, {
        id: user._id,
        token: user.token,
      });
      navigate("/dataPermohonan");
      await getDataPermohonans();
    } catch (err) {
      handleAuthError(err);
      setDeleteError(err.response?.data?.message || "Gagal menghapus data permohonan.");
      setLoading(false);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Survey</div>
          <h1 className="page-title">Data Permohonan</h1>
        </div>
        <Button className="btn-icon" size="sm" onClick={() => navigate("/dataPermohonan/tambahDataPermohonan")}>
          <MdAdd /> Tambah
        </Button>
      </div>
      {error && <Alert variant="warning">{error}</Alert>}

      {isDataPermohonanExist && (
        <section className="section-panel">
          <div className="toolbar mt-0">
            <div className="detail-title-actions">
              <Button className="btn-back" size="sm" variant="outline-secondary" onClick={() => navigate("/dataPermohonan")}>
                {"< Kembali"}
              </Button>
              <div>
                <h2 className="h6 fw-bold mb-1">Detail Data Permohonan</h2>
                <div className="text-muted">{namaPemohon?.permohonan?.namaPemohon}</div>
              </div>
            </div>
            <div className="d-flex gap-2 flex-wrap">
              <Button className="btn-icon" size="sm" variant="outline-primary" onClick={() => navigate(`/dataPermohonan/${id}/edit`)}>
                <MdEdit /> Ubah
              </Button>
              <Button className="btn-icon" size="sm" variant="outline-danger" onClick={() => setShowDeleteConfirm(true)}>
                <MdDelete /> Hapus
              </Button>
            </div>
          </div>
          <hr />
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <div className="detail-label">Nama Pemohon</div>
                <div className="detail-value">{namaPemohon?.permohonan?.namaPemohon || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Alasan</div>
                <div className="detail-value">{namaPemohon?.alasanSetuju || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Status Dokumen</div>
                <div className="detail-value">{statusDokumen || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Keterangan Susulan</div>
                <div className="detail-value">{keteranganSusulan || "-"}</div>
              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <div className="detail-label">No Jual</div>
                <div className="detail-value">{noJual || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Nopol</div>
                <div className="detail-value">{nopol || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Alamat</div>
                <div className="detail-value">{alamat || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Status RO</div>
                <div className="detail-value">{statusRo || "-"}</div>
              </div>
              <div className="mb-3">
                <div className="detail-label">Butuh Verifikasi</div>
                <div className="detail-value">{butuhVerifikasi || "-"}</div>
              </div>
            </Col>
          </Row>
        </section>
      )}

      <Form onSubmit={searchData}>
        <div className="search-row">
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button type="submit">Cari</Button>
        </div>
      </Form>
      <ShowTableDataPermohonan currentPosts={dataPermohonansData} />
      <div className="search-row">
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </div>
      <ConfirmDeleteDialog
        show={showDeleteConfirm}
        message={`Yakin ingin menghapus data admin ${namaPemohon?.permohonan?.namaPemohon}?`}
        onCancel={() => setShowDeleteConfirm(false)}
        onConfirm={deleteDataPermohonan}
      />
      <InfoDialog
        show={Boolean(deleteError)}
        title="Data Tidak Bisa Dihapus"
        message={deleteError}
        onClose={() => setDeleteError("")}
      />
    </div>
  );
};

export default TampilDataPermohonan;

